import produce from 'immer';
import { Reducer } from 'redux';

import { IDataListState, IDataListActionsType, IDataListTypes } from './types';

const INITIAL_STATE: IDataListState = {
  loading: false,
  loadingSave: false,
  loadingActivation: false,
  loadingGetDataList: false,
  loadingGetMetadataTemplate: false,
  loadingGetMetadataFile: false,
  loadingGetMetadataFileByName: false,

  sortOrder: 'desc',
  sortBy: 'updated_at',

  totalDataLists: 0,
  totalMetadata: 0,

  dataList: null,
  dataLists: [],
  metadata: null,
};

const dataList: Reducer<IDataListState, IDataListActionsType> = (
  state = INITIAL_STATE,
  action: IDataListActionsType,
) => {
  return produce(state, (draft) => {
    switch (action.type) {
      case IDataListTypes.GET_DATA_LIST_REQUEST: {
        draft.loadingGetDataList = true;
        break;
      }
      case IDataListTypes.GET_DATA_LIST_SUCCESS: {
        draft.loadingGetDataList = false;
        draft.dataList = action.payload.dataList;
        break;
      }
      case IDataListTypes.GET_DATA_LIST_FAILURE: {
        draft.loadingGetDataList = false;
        break;
      }
      case IDataListTypes.GET_DATA_LIST_METADATA_REQUEST: {
        draft.loading = true;
        break;
      }
      case IDataListTypes.GET_DATA_LIST_METADATA_SUCCESS: {
        draft.loading = false;
        draft.totalMetadata = action.payload.total;
        draft.metadata = action.payload.metadata;
        break;
      }
      case IDataListTypes.GET_DATA_LIST_METADATA_FAILURE: {
        draft.loading = false;
        draft.metadata = [];
        break;
      }
      case IDataListTypes.LIST_DATA_LIST_REQUEST: {
        draft.loading = true;
        draft.dataList = null;
        break;
      }
      case IDataListTypes.LIST_DATA_LIST_SUCCESS: {
        draft.loading = false;
        draft.dataLists = action.payload.dataLists;
        draft.sortOrder = action.payload.sortOrder;
        draft.sortBy = action.payload.sortBy;
        draft.totalDataLists = Number(action.payload.total);
        break;
      }
      case IDataListTypes.LIST_DATA_LIST_FAILURE: {
        draft.loading = false;
        break;
      }
      case IDataListTypes.ACTIVATE_DATA_LIST_REQUEST: {
        draft.loadingActivation = true;
        break;
      }
      case IDataListTypes.ACTIVATE_DATA_LIST_SUCCESS: {
        draft.loadingActivation = false;
        if (draft.dataLists) {
          const dataListIndex = draft.dataLists.findIndex(
            (dataList) => dataList.id === action.payload.data_list_id,
          );
          draft.dataLists[dataListIndex].active = action.payload.active;
        }
        break;
      }
      case IDataListTypes.ACTIVATE_DATA_LIST_FAILURE: {
        draft.loadingActivation = false;
        break;
      }
      case IDataListTypes.SAVE_DATA_LIST_REQUEST: {
        draft.loadingSave = true;
        break;
      }
      case IDataListTypes.SAVE_DATA_LIST_SUCCESS: {
        draft.loadingSave = false;
        break;
      }
      case IDataListTypes.SAVE_DATA_LIST_FAILURE: {
        draft.loadingSave = false;
        break;
      }
      case IDataListTypes.CLEAR_DATA_LIST_REQUEST: {
        draft.dataList = null;
        draft.sortOrder = 'desc';
        draft.sortBy = 'updated_at';
        break;
      }
      case IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_REQUEST: {
        draft.loadingGetMetadataTemplate = true;
        break;
      }
      case IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_SUCCESS: {
        draft.loadingGetMetadataTemplate = false;
        break;
      }
      case IDataListTypes.GET_METADATA_TEMPLATE_DATA_LIST_FAILURE: {
        draft.loadingGetMetadataTemplate = false;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_DATA_LIST_REQUEST: {
        draft.loadingGetMetadataFile = true;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_DATA_LIST_SUCCESS: {
        draft.loadingGetMetadataFile = false;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_DATA_LIST_FAILURE: {
        draft.loadingGetMetadataFile = false;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_REQUEST: {
        draft.loadingGetMetadataFileByName = true;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_SUCCESS: {
        draft.loadingGetMetadataFileByName = false;
        break;
      }
      case IDataListTypes.GET_METADATA_FILE_BY_NAME_DATA_LIST_FAILURE: {
        draft.loadingGetMetadataFileByName = false;
        break;
      }
      default:
    }
  });
};
export default dataList;
